import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../../styles/theme";
import { GuideData } from "../../types";
import javascriptHandler from "../../apis/javascriptHandler";
import Caption from "./Caption";

interface Props {
   item: GuideData;
}

export const bannerStyles = {
   alignItems: "initial",
   justifyContent: "initial",
   borderRadius: "10px",
   width: "100%",
   marginBottom: "28px",
   position: "relative",
   boxShadow: "0px 3px 15px 0px rgba(0,0,0,0.09)",
};

const useStyles = createUseStyles((theme: ThemeType) => ({
   banner: (props: Props) => ({
      width: "100%",
      position: "relative",
      backgroundSize: "100% auto",
      backgroundColor: props.item.keyColor,
      background: `url(${props.item.img}) bottom center no-repeat`,
      boxShadow: "0px 3px 15px 0px rgba(0,0,0,0.09)",
      alignItems: "initial",
      borderRadius: "10px",
      marginBottom: "28px",
      paddingBottom: "calc(100% - 154px)",
      justifyContent: "initial",
   }),
}));

const Banner: React.FC<Props> = (props) => {
   const classes = useStyles(props);
   const navigate = useNavigate();
   const { item } = props;
   const handleClick = useCallback((id: number) => {
      // history.push(`guide/${id}`)
      javascriptHandler._callHandler("OpenWebView", `guide/${id}`);
   }, []);

   return (
      <div
         className={classes.banner}
         key={item.id}
         onClick={() => handleClick(item.id)}
      >
         <Caption item={item} isGuideDetailPage={false} />
      </div>
   );
};

export default Banner;
